import { Injectable } from '@angular/core';
import { LoggerService } from '@psnb/services';
import { LogItemDetail } from '@psnb/services';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  //Added for Generator Permissions
  public static readonly CREATE_GENERATOR: string = 'Create Generator';
  public static readonly DELETE_GENERATOR: string = 'Delete Generator';
  public static readonly EDIT_GENERATOR_DETAILS: string = 'Edit Generator';
  public static readonly GENERATOR_ADMIN_FUNCTIONS: string = 'Generator Admin functions';
  public static readonly GENERATOR_ADMIN_ONLY: string = 'Generator Administrator';
  public static readonly GENERATOR_RECOVERY_DEPLOY_BUTTON: string = 'Deploy/Recover Generator';

  private logItemDetails:LogItemDetail;
  userpermissions:any;
  static readonly ENABLED = "Enabled";
  static readonly DISABLED = "Disabled";
  static readonly READONLY = "Read Only";
  static readonly TELEMETRYDATATAB = "Telemetry Data tab";
  static readonly TRANSPONDEROPSTAB = "Transponder Operations tab";
  static readonly DISPLAYPAGE = "Displays page";
  static readonly TRANSPONDEROPSTABPSALERTBTN = "Power Supply Alert Button";
  static readonly TRANSPONDEROPSTABREMOTESELFTESTSTARTBTN = "Remote Self Test Start Button";
  static readonly TRANSPONDEROPSTABREMOTESELFTESTSTOPBTN = "Remote Self Test Stop Button";
  //static readonly TRANSPONDEROPSTABHMRESETBTN = "HMS Reset Button";
  static readonly TRANSPONDEROPS_TAB_CM_KICKSTART_BTN = "CM KickStart Button";
  static readonly TRANSPONDEROPSTABCMRESETBTN = "CM Reset Button";
  static readonly TRANSPONDEROPSTABEDITTESTDURATIONBTN = "Edit Test Duration Button";
  static readonly TRANSPONDEROPSTABREFRESHDATABTN = "Refresh Data Button";
  static readonly TRANSPONDEROPSRMODE = "Rmode";
  static readonly TELEMETRY = "Telemetry Data tab";

  static readonly SEARCHBYNODE = "Search by node";
  static readonly CREATEPS = "Create Power Supply Button";

  static readonly DETAILSICONCAT = "Details Icon";
  static readonly DETAILSICON = "Details Icon";
  static readonly EDITICONCAT = "Edit Icon";
  static readonly EDITICON = "Edit Icon";
  static readonly ALERTICONCAT="Alert Icon";
  static readonly ALERTICON="Alert Icon";
  static readonly TELEMETRYICONCAT="Telemetry Icon";
  static readonly TELEMETRYICON="Telemetry Icon";

  static readonly POWERSUPPLYDETAILS = "Power Supply Details";
  static readonly SHOWLOCATION = "Show Location";
  static readonly SHOWTRANSPONDER = "Show Transponder";
  static readonly SHOWBATTERY = "Show Battery";
  static readonly SHOWLASTVISIT = "Show Last Visit";
  static readonly SHOWPHOTOS ="Show Photos";
  static readonly SHOWALERTSEVENTS = "Show Alerts/Events";
  static readonly SHOWHISTORY = "Show History";
  static readonly XM360REPORTBUTTON="XM360 Report Button";

  static readonly PSALERTSPAGE = "Power Supply Alerts";
  static readonly PSALERTSPAGEFUNC = "PS alerts page";

  static readonly POWERSUPPLYEDIT = "Power Supply Edit";
  static readonly EDITLOCATION = "Edit Location Info";
  static readonly EDITTRANSPONDERINFO = "Edit Transponder Info";
  static readonly EDITBATTERYINFO = "Edit Battery Info";
  static readonly EDITLASTVISITINFO = "Edit Last Visit Info";
  static readonly EDITPHOTOS ="Edit Photo(s)";
  static readonly EDITLASTCERTIFICATION = "Last Certification";
  static readonly ADDAPUINFO="Add APU Info";
  static readonly ADDAPUVISIT="Add APU Visit";
  static readonly MACADDRESSLINK="Mac Address Link";
  static readonly ALERTSEVENTS = 'Alerts/Events';
  static readonly ADMIN_ROLE = "Administrator";

  //Edit PS Constant Message for PS Update
  static readonly GencallsetDurationtruetrue = 'Genome Transponder call Successful, Genome Set Test Duration call successful and PowerSupply updated successfully';
  static readonly GencallsetDurationfalsefalse = 'Genome Transponder call not Successful, Genome Set Test Duration call not successful and PowerSupply updated successfully';
  static readonly GencallsetDurationtruefalse = 'Genome Transponder call Successful, Genome Set Test Duration call not successful and PowerSupply updated successfully';
  static readonly GencallsetDurationfalsetrue = 'Genome Transponder call not Successful, Genome Set Test Duration call successful and PowerSupply updated successfully';
  static readonly GenomeMsg = 'Successfully updated the power supply';

  public constructor(private loggerService: LoggerService) {
  }

  //Common function for permission check
  permissionlevel(level){
    if(level === CommonService.ENABLED) {
      return 0;
    } else if(level === CommonService.DISABLED){
      return 1;
    } else if(level === CommonService.READONLY){
      return 2;
    }
  }

  decimalCount (number) {
    // Convert to String
    const numberAsString = number.toString();
    // String Contains Decimal
    if (numberAsString.includes('.')) {
      return numberAsString.split('.')[1].length;
    }
    // String Does Not Contain Decimal
    return 0;
  }

  //Common function for Admin check
  checkAdminPermission(){
    this.userpermissions = JSON.parse(localStorage.getItem('user-permissions'));
    for (let element of this.userpermissions) {
      if(element.role == CommonService.ADMIN_ROLE){
        return true;
      }else{
        return false;
      }
    }
  }

  loggerPost(message, activity, level) {
    this.setLogItemDetails(activity);
    this.loggerService.loggerPost(message, this.logItemDetails, level, environment.scope);
  }

  setLogItemDetails(activity) {
    this.logItemDetails = {
      type: '',
      environment: environment.env,
      system: environment.system,
      subsystem: environment.subsystem,
      component: '',
      activity,
      start: 0,
      stop: 0,
      duration: 0,
      xresolution: window.innerWidth,
      yresolution: window.innerHeight
    };
  }

  public  getContinuityLinksForDivisionFromEnv(macAddress:string, division:String) {
    if (macAddress !== null && macAddress !== undefined && macAddress !== '') {
        let dstMacStr = '&dst=dv&mac=' + macAddress;
        let windowUrl : any;
        if (division === 'Central Div')
            windowUrl = environment.continuityUrls.central + dstMacStr;
        else if (division === 'West Div')
            windowUrl = environment.continuityUrls.west + dstMacStr;
        else
            windowUrl = environment.continuityUrls.ned +dstMacStr;
        return windowUrl;
    }
  }

  public getUnifiedPSAlertProfile(acInputVoltage:string,
    outputVoltage : string, inputCurrent : string,
     numberOfBatteries : string, division: string) : string{
    let unifiedAlertProfile = '';
    let BatteryString = '';
    let InputVoltageString = '';
    let OutputVoltageString = '';
    let InputCurrent = '';
    //let CurrentAmpOutput = '';

    if (division == 'Northeast Div' || division == 'West Div' || division == 'Central Div') {
      if (numberOfBatteries !== undefined && numberOfBatteries !== '') {
        if (numberOfBatteries == '0 String Of 0') {
          BatteryString = '0BattString'
        } else if (numberOfBatteries == '1 String Of 1') {
          BatteryString = '1BattString'
        } else if (numberOfBatteries == '1 String Of 2') {
          BatteryString = '2BattString'
        } else if (numberOfBatteries == '1 String Of 3') {
          BatteryString = '3BattString'
        } else if (numberOfBatteries == '1 String Of 4') {
          BatteryString = '4BattString'
        } else if (numberOfBatteries == '2 Strings Of 3') {
          BatteryString = '3BattString'
        } else if (numberOfBatteries == '2 Strings Of 4') {
          BatteryString = '4BattString'
        } else if (numberOfBatteries == '3 Strings Of 3') {
          BatteryString = '3BattString'
        } else if (numberOfBatteries == '3 Strings Of 4') {
          BatteryString = '4BattString'
        } else if (numberOfBatteries == '4 Strings Of 3') {
          BatteryString = '3BattString'
        } else if (numberOfBatteries == '4 Strings Of 4') {
          BatteryString = '4BattString'
        } else if (numberOfBatteries == '5 Strings Of 2') {
          BatteryString = '2BattString'
        } else if (numberOfBatteries == '5 Strings Of 3') {
          BatteryString = '3BattString'
        } else if (numberOfBatteries == '5 Strings Of 4') {
          BatteryString = '4BattString'
        } else if (numberOfBatteries == '6 Strings Of 3') {
          BatteryString = '3BattString'
        } else if (numberOfBatteries == '6 Strings Of 4') {
          BatteryString = '4BattString'
        }else if(numberOfBatteries == 'Parallel 2 Batteries'){
          BatteryString = '2battstring(Parallel)'
        }
        else if(numberOfBatteries == 'Parallel 3 Batteries'){
          BatteryString = '3battstring(Parallel)'
        }
        else if(numberOfBatteries == 'Parallel 4 Batteries'){
          BatteryString = '4battstring(Parallel)'
        }
        else if(numberOfBatteries == 'Parallel 5 Batteries'){
          BatteryString = '5battstring(Parallel)'
        }
        else if(numberOfBatteries == 'Parallel 6 Batteries'){
          BatteryString = '6battstring(Parallel)'
        }
        else if(numberOfBatteries == '1LionBMS'){
          BatteryString = '1LionBMS'
        }
		    else {
          BatteryString = '';
        }
      }
      if (acInputVoltage !== null && acInputVoltage !== undefined && acInputVoltage !== '' && acInputVoltage.indexOf('VAC') > -1 ) {
          InputVoltageString = acInputVoltage.replace('VAC', 'Vin');
      }

      if (outputVoltage !== null && outputVoltage !== undefined && outputVoltage !== ''  && outputVoltage.indexOf('VAC') > -1 ) {
          OutputVoltageString = outputVoltage.replace('VAC','Vout');
      }

      if (inputCurrent !== null && inputCurrent !== undefined) {
        InputCurrent = inputCurrent;
      }

      // if (currentAmpOutput !== null && currentAmpOutput !== undefined) {
      //   CurrentAmpOutput = currentAmpOutput;
      // }
      if (BatteryString === '' && BatteryString === '' && InputVoltageString === '' && OutputVoltageString === '' && InputCurrent === '') {
        unifiedAlertProfile = '';
      } else {
        unifiedAlertProfile = BatteryString + "-" + InputVoltageString + "-" + OutputVoltageString + "-" + InputCurrent;
      }
    }
    return unifiedAlertProfile;
  }
}
